import { produce } from "immer";

export const initialState = {
  activeSection: "apps",
  isLeftMenuCollpsed: false,
};

/* eslint-disable default-case, no-param-reassign */
const leftMenuReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // case "SET_VERSION":
      //   draft.version = "v" + action.payload;
      case "ACTIVE_LEFT_MENU":
        draft.activeSection = action.payload.data;
        break;

      case "COLLAPSE_LEFT_MENU":
        draft.isLeftMenuCollpsed = action.payload.data;
        break;
    }
  });

export default leftMenuReducer;
